/* cpg-variant-sync.js — robust variant → media sync with legacy image-id mapping */
(function () {
  const root = document.getElementById('custom-product-gallery');
  if (!root) return;

  const $ = (sel, el=document) => el.querySelector(sel);
  const $$ = (sel, el=document) => Array.from(el.querySelectorAll(sel));

  function getProductJSON() {
    let el =
      $('script[type="application/json"][data-product]') ||
      $('script[type="application/json"][id^="ProductJson"]') ||
      $('script[type="application/json"][id^="ProductData"]') ||
      $('script[type="application/json"]', root.closest('section, .product, form')) ||
      $('script[type="application/json"]');
    if (!el) return null;
    try {
      const obj = JSON.parse(el.textContent.trim());
      return obj && obj.variants ? obj : null;
    } catch { return null; }
  }

  // Build helpers for mapping legacy image-id or URL -> media.id
  function buildMediaLookups(product) {
    const imageIdToMediaId = new Map();  // legacy image.id -> media.id
    const srcToMediaId     = new Map();  // normalized src -> media.id

    (product.media || []).forEach(m => {
      const mediaId = String(m.id);
      const imageObj = m.image || m.preview_image || m.previewImage || null;

      if (imageObj?.id) {
        imageIdToMediaId.set(String(imageObj.id), mediaId);
      }

      // normalize src, strip query params and CDN size suffixes
      const rawSrc = imageObj?.src || m.src || m.preview_image?.src || m.previewImage?.src;
      if (rawSrc) {
        const clean = normalizeSrc(rawSrc);
        srcToMediaId.set(clean, mediaId);
      }
    });

    return { imageIdToMediaId, srcToMediaId };
  }

  function normalizeSrc(u) {
    try {
      const url = new URL(u, location.origin);
      url.search = '';
      // shopify image URLs sometimes end with _{size}.ext, drop that part for matching
      url.pathname = url.pathname.replace(/_(?:[0-9]+x|[a-z]+)\.(jpg|jpeg|png|webp|gif)$/i, '.$1');
      return url.toString();
    } catch {
      // fallback for relative or plain strings
      return String(u).split('?')[0].replace(/_(?:[0-9]+x|[a-z]+)\.(jpg|jpeg|png|webp|gif)$/i, '.$1');
    }
  }

  function buildVariantToMediaMap(product, lookups) {
    const { imageIdToMediaId, srcToMediaId } = lookups;
    const v2m = new Map();

    (product.variants || []).forEach(v => {
      // 1) best: featured_media.id
      let mediaId =
        v?.featured_media?.id ||
        v?.featured_media_id ||
        null;

      // 2) legacy: featured_image.id -> translate to media.id
      if (!mediaId && v?.featured_image?.id) {
        const translated = imageIdToMediaId.get(String(v.featured_image.id));
        if (translated) mediaId = translated;
      }

      // 3) ultimate fallback via URL match
      if (!mediaId && v?.featured_image?.src) {
        const m = srcToMediaId.get(normalizeSrc(v.featured_image.src));
        if (m) mediaId = m;
      }

      if (v?.id && mediaId) {
        v2m.set(String(v.id), String(mediaId));
      }
    });

    return v2m;
  }

  function goToMedia(mediaId) {
    if (!mediaId) return;

    // Prefer clicking PLP thumb, then modal thumb, to reuse existing handlers
    const plpThumb = $(`.cpg-plp-thumb[data-media-id="${mediaId}"]`, root);
    if (plpThumb) {
      plpThumb.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    } else {
      // fallback, try clicking the slide itself if you have handlers on it
      const plpSlide = $(`[data-track] > [data-media-id="${mediaId}"]`, root);
      if (plpSlide) plpSlide.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    }

    const modalThumb = $(`.cpg-thumb[data-media-id="${mediaId}"]`, root);
    if (modalThumb) {
      modalThumb.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    }
  }

  function getVariantInput() {
    const form = root.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    return $('input[name="id"]', form);
  }

  const product = getProductJSON();
  if (!product) return;

  const lookups = buildMediaLookups(product);
  const v2m     = buildVariantToMediaMap(product, lookups);

  // Initial sync
  const explicitInitial = root.getAttribute('data-initial-media-id');
  if (explicitInitial) {
    goToMedia(String(explicitInitial));
  } else {
    const vi = getVariantInput();
    if (vi && v2m.has(String(vi.value))) {
      goToMedia(v2m.get(String(vi.value)));
    }
  }

  // Observe variant changes through the hidden input value, plus node replacement
  const variantInput = getVariantInput();
  if (!variantInput) return;

  let lastVal = variantInput.value;

  const onMaybeChanged = () => {
    const cur = variantInput.value;
    if (cur !== lastVal) {
      lastVal = cur;
      const mediaId = v2m.get(String(cur));
      if (mediaId) goToMedia(mediaId);
    }
  };

  variantInput.addEventListener('input', onMaybeChanged, { passive: true });
  variantInput.addEventListener('change', onMaybeChanged, { passive: true });

  const mo = new MutationObserver(onMaybeChanged);
  mo.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

  const form = variantInput.closest('form');
  if (form) {
    const mo2 = new MutationObserver(() => {
      const fresh = $('input[name="id"]', form);
      if (fresh && fresh !== variantInput) {
        lastVal = fresh.value;
        fresh.addEventListener('input', onMaybeChanged, { passive: true });
        fresh.addEventListener('change', onMaybeChanged, { passive: true });
        mo.observe(fresh, { attributes: true, attributeFilter: ['value'] });
      }
    });
    mo2.observe(form, { childList: true, subtree: true });
  }
})();
